export default __webpack_public_path__ + "27b0960.png";